import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TenantService } from '../../../core/tenant/tenant.service';

@Component({
  selector: 'kt-device-care-modal',
  templateUrl: './device-care-modal.component.html',
  styleUrls: ['./device-care-modal.component.scss']
})
export class DeviceCareModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DeviceCareModalComponent>,
    public tenant: TenantService
  ) { }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }

}
